import React from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem
} from '@chakra-ui/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Auth } from "../../lib/Auth";
import moment from 'moment';

const FormItem = ({ form, onSign, onDownload, onCancel, idx }) => {
  const { business, created, title, _id, signature_request_id, is_complete } = form;

  return (
    <Box key={_id} borderWidth="1px" borderRadius="lg" mb={4} width="100%" className="actionableItem">
      <Flex direction="column" p={4} justify="space-between" height="100%">
        <Flex justify="space-between" align="right" textAlign="left">
          <Box>
            <Text fontSize="sm"> Title: <b>{title}</b></Text>
            <Text fontSize="sm"> Created on: <b>{moment(created).format('MMMM Do YYYY, h:mm:ss a')}</b></Text>
            {business && <Text fontSize="sm" fontWeight="bold">{business}</Text>}
          </Box>
          <Flex alignItems="center" gap={4}>
            {!is_complete && (
              <Flex direction="column" alignItems="center">
                <Button onClick={() => onSign(signature_request_id)}>
                  Sign
                </Button>
              </Flex>
            )}
            <Flex>
              <Menu direction={"flex-end"}>
                <MenuButton as={IconButton} aria-label="Options" icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                            variant="ellipsis"/>
                <MenuList>
                  {!Auth.user.isPatient && !is_complete &&
                    <MenuItem id={`edit-${idx}`} color="red.500" onClick={() => onCancel(signature_request_id)}>Cancel</MenuItem>}
                  <MenuItem id={`dnl-${idx}`}
                            onClick={(e) => {
                              e.preventDefault();
                              onDownload(signature_request_id, title);
                            }}>Download as PDF</MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default FormItem;
